import React, { useState } from 'react'
import { SelectAsync } from '@arnsbogroup/react-voicearchive'
import debounce from 'debounce-promise'
import messages from "./messages";
import {FormattedMessage, useIntl} from "react-intl";

const DefaultContacts = ({ primary, secondary, setPrimary, setSecondary, name = "", resolveUrl, labelKey = 'name' }) => {
  const { formatMessage } = useIntl()
  const loadOptions = debounce((query) => {
    return new Promise((resolve, reject) => {
      fetch(resolveUrl(query))
        .then(response => response.json())
        .then((list) => {
          resolve(list.map((item) => ({ value: item.uid, label: item[labelKey] })))
        })
        .catch(reject)
    })
  }, 250)

  return (
    <div className="">
      <div className="">
        <div className="text-gray-500 mb-2"><FormattedMessage {...messages.primary}/> { name }</div>
        <SelectAsync
          value={primary}
          onChange={(value) => { value ? setPrimary(value) : setPrimary({value: null, label: null}) }}
          cacheOptions
          loadOptions={loadOptions}
          defaultOptions
          placeholder={`${formatMessage(messages.primary)} ${name}`}
          isClearable
        />
      </div>

      <div className="mt-2">
        <div className="text-gray-500 mb-2"><FormattedMessage {...messages.secondary}/> { name }</div>
        <SelectAsync
          value={secondary}
          onChange={(value) => { value ? setSecondary(value) : setSecondary({value: null, label: null}) }}
          cacheOptions
          loadOptions={loadOptions}
          defaultOptions
          placeholder={`${formatMessage(messages.secondary)} ${name}`}
          isClearable
        />
      </div>
    </div>
  )
}

export default DefaultContacts
